var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col items-center justify-center gap-y-[10px]",style:({ height: `${_vm.height}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }